<template>
  <b-container fluid>
    <b-row no-gutters>
      <b-col cols="12" class="mb-3">
        <h1>Privacy Policy</h1>
        <p>You can edit the privacy policy below. Please check your work for spelling errors before saving the changes. You can also preview your changes before saving by clicking the preview button.</p>
        <b-button variant="secondary" :to="{name: 'privacyPolicy'}" target="_BLANK" class="mb-3">
          Open in new tab
          <b-icon-box-arrow-up-right />
        </b-button>
        <ckeditor :editor="editor" v-model="privacyPolicy.data" @ready="onReady" />
      </b-col>
      <b-col cols="3">
        <b-button variant="primary" @click="save" class="mr-3">Save</b-button>
        <b-button
          variant="outline-primary"
          :to="{name: 'privacyPolicy', params: {policy: privacyPolicy}}"
        >
          preview
          <b-icon-box-arrow-up-right />
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {PrivacyPolicy} from '@/fstore/collections/siteDocuments'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
  name: "PrivacyPolicy",
  data () {
    return {
      editor: DecoupledEditor,
      privacyPolicy: {
        created: new Date(),
        data: '',
        modified: new Date()
      },
    }
  },
  async created () {
    if(this.$route.params.policy)
      this.privacyPolicy = this.$route.params.policy
    else
      this.privacyPolicy = await PrivacyPolicy.get();
  },
  methods: {
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    async save () {
      this.$store.dispatch('app/setOverlay', true);
      await PrivacyPolicy.set(this.privacyPolicy);
      this.$store.dispatch('app/setOverlay', false);
    }
  }
}
</script>

<style>
.ck.ck-content.ck-editor__editable.ck-editor__editable_inline {
  height: 768px;
  max-height: 768px;
  border: solid 1px #c4c4c4;
  border-top: none;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}
</style>